import { FC } from 'react';
import { CampaignTraitStepItem } from './types';
import { DistributionChannelConnector } from '@/models/distributionChannels';
import { Checkbox } from '@/components/inputs';
import { ConnectorInfo } from './ConnectorInfo';

type DestinationItemDataProps = {
  data: CampaignTraitStepItem;
  setField: (connector: DistributionChannelConnector, fieldId: number, checked: boolean) => void;
};

export const DestinationItemData: FC<DestinationItemDataProps> = ({ data, setField }) => {
  const { connector, selectedFields, distributionChannelContent } = data;
  const changeField = (fieldId: number, checked: boolean) => {
    setField(connector, fieldId, checked);
  };

  return (
    <div className='grid grid-cols-[540px_1fr]'>
      <ConnectorInfo connector={connector} />

      <div className='flex flex-col gap-4'>
        {distributionChannelContent.integrationsResult.cyclr.action.fields
          .filter((x) => !x.name.toLowerCase().includes('[script]'))
          .map((field, i, fields) => (
            <Checkbox
              key={field.fieldId}
              label={field.name}
              id={field.fieldId + ''}
              description={field.description}
              disabled={!field.isOptional}
              required={!field.isOptional}
              forceShowingDescription={i !== fields.length - 1}
              checked={selectedFields[field.fieldId]}
              onChange={(e) => changeField(field.fieldId, e.target.checked)}
            />
          ))}
      </div>
    </div>
  );
};
